import React from 'react';

import PropTypes from 'prop-types';

import Group from '@asteria/component-core/group';
import { TooltipContent } from '@asteria/component-core/tooltip';
import { Text } from '@asteria/component-core/typography';
import Wrapper, { Content, Header } from '@asteria/component-core/wrapper';

import Prefix from '@asteria/component-prefix';
import { useFeature } from '@asteria/component-tools/featureflag';

import { useTranslate } from '@asteria/language';
import { cn } from '@asteria/utils-funcs/classes';

import { useDate } from '../../../hooks';

import './styles.scss';

const AccountBalanceTooltipSection = (props) => {
	const { type, date, value /* min, max */ } = props;

	const { t } = useTranslate();

	const { isCurrent, isPast, isFuture } = useDate(date);

	const colors = React.useMemo(() => {
		if (type === 'overview') {
			return 'account asteria-color__forecast';
		}

		return type;
	}, [type]);

	return (
		<div
			className={cn('asteria-component__forecaster-tooltip__section', {
				[`asteria-component__forecaster-tooltip__section--type-${type}`]:
					type,
			})}
		>
			<Group direction="horizontal" verticalAlign="center">
				<Prefix colors={colors} size="sm" />
				<Text size="sm">
					{t(
						[
							`forecaster.account.balance.label`,
							`forecaster.account.balance.${type}.label`,
						]
							.concat(
								isCurrent
									? [
										`forecaster.account.balance.current.label`,
										`forecaster.account.balance.current.${type}.label`,
									]
									: [],
							)
							.concat(
								isFuture
									? [
										`forecaster.account.balance.future.label`,
										`forecaster.account.balance.future.${type}.label`,
									]
									: [],
							)
							.concat(
								isPast
									? [
										`forecaster.account.balance.past.label`,
										`forecaster.account.balance.past.${type}.label`,
									]
									: [],
							),
					)}
				</Text>
				<Text align="right" size="sm">
					{t(
						[
							`forecaster.account.balance.total`,
							`forecaster.account.balance.${type}.total`,
						],
						{
							default: '{{ total | number }}',
							data: { total: value },
						},
					)}
				</Text>
			</Group>
			{/* {['deposit', 'withdraw'].includes(type) &&
			(isCurrent || isFuture) &&
			min !== max ? (
				<Group
					direction="horizontal"
					verticalAlign="center"
					className="asteria-component__forecaster-tooltip__section--type-spread"
				>
					<span className="asteria-component__forecaster-tooltip__section__empty" />
					<Text size="xs">
						{t(
							[
								'forecaster.account.balance.spread',
								`forecaster.account.balance.${type}.spread`,
							],
							{data: { min: min, max: max }}
						)}
					</Text>
				</Group>
			) : null} */}
		</div>
	);
};

AccountBalanceTooltipSection.displayName = 'AccountBalanceTooltipSection';

AccountBalanceTooltipSection.propTypes = {
	type: PropTypes.string,
	date: PropTypes.string,

	value: PropTypes.number,
	min: PropTypes.number,
	max: PropTypes.number,
};

const AccountBalanceTooltip = (props) => {
	const { className, date, data } = props;

	const { t } = useTranslate();

	const hasHorizontalFeature = useFeature(
		'forecaster-account-balance-horizontal-tooltip',
	);

	const direction = hasHorizontalFeature ? 'horizontal' : 'vertical';

	const headerTitle = t(
		['forecaster.account.balance.header'],
		// eslint-disable-next-line spellcheck/spell-checker
		{ default: 'Kontobalans' },
	);

	const overview = data ?? { value: 0 }; //useOverviewValues({ date, onSubmit });
	const deposit = data?.deposit ?? { value: 0 }; //useTypedValues({ date, type: 'deposit' });
	const withdraw = data?.withdraw ?? { value: 0 }; //useTypedValues({ date, type: 'withdraw' });

	return (
		<TooltipContent
			className={cn(
				'asteria-component__forecaster-tooltip',
				'asteria-component__forecaster-tooltip--type-account',
				{ [`asteria--direction-${direction}`]: direction },
				className,
			)}
		>
			<Wrapper>
				{headerTitle ? (
					<Header>
						<Text weight="medium" align="center" size="sm">
							{headerTitle}
						</Text>
					</Header>
				) : null}

				<Content>
					<Group direction="vertical">
						<AccountBalanceTooltipSection
							type="overview"
							date={date}
							value={overview?.value}
						// min={overview?.min}
						// max={overview?.max}
						/>
						<Group direction={direction}>
							<AccountBalanceTooltipSection
								type="deposit"
								date={date}
								value={deposit?.value}
							// min={deposit?.min}
							// max={deposit?.max}
							/>
							<AccountBalanceTooltipSection
								type="withdraw"
								date={date}
								value={withdraw?.value}
							// min={withdraw?.min}
							// max={withdraw?.max}
							/>
						</Group>
					</Group>
				</Content>
			</Wrapper>
		</TooltipContent>
	);
};

AccountBalanceTooltip.displayName = 'AccountBalanceTooltip';

AccountBalanceTooltip.propTypes = {
	className: PropTypes.string,
	date: PropTypes.string,
};

export default AccountBalanceTooltip;
